import pubsub from "@viewlift/pubsub"
const publishHBAModal = (data) => {
     //enable the hba modal on checkout
     pubsub.publish('enable-hba-modal', data)
}

const subscribeHBAModal = (cb) => {
    //enable the hba modal on checkout
    pubsub.subscribe('enable-hba-modal', cb)
}
const redirectToHomePage = () => {
    pubsub.publish('redirect',"/")
}

export {publishHBAModal, subscribeHBAModal, redirectToHomePage}